<div class="top-header" *ngIf="curentUser">
  <div class="user-options ml-auto">
    <span>{{ curentUser?.data?.name }}</span>
    <ng-container *ngIf="curentUser?.data?.avatar; else elseTemplate">
      <p-avatar
        [image]="curentUser?.data?.avatar?.url"
        styleClass="ml-2"
        shape="circle"
      ></p-avatar>
    </ng-container>
    <ng-template #elseTemplate>
      <p-avatar
        shape="circle"
        styleClass="text-black-alpha-90 ml-2"
        [label]="curentUser?.data?.name[0]"
      ></p-avatar>
    </ng-template>

    <div class="user-option-dropdown">
      <button class="dropdown-item" type="button" (click)="onLogout()">
        Sign out <i class="pi pi-sign-out"></i>
      </button>
    </div>
  </div>
</div>
<!-- <app-header-alert [display]="true">
  Update sajta je trenutno u toku.
</app-header-alert> -->
